<script lang="ts">
	import { onMount } from 'svelte';
	import { get } from 'svelte/store';
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	import { home_data } from 'src/stores/account/user';
	import { digitFormat } from 'src/helpers/date_helper';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { ButtonV2, SelectV2, Stack, Text } from '@Shelly/shelly-design-system';

	let dayOptions: string[] = [];
	let selectedDay = '';
	let initialDay = '';

	onMount(() => {
		dayOptions = Array.from({ length: 28 }, (_, i) =>
			$format('of_the_month', {
				values: { day: digitFormat(i + 1) },
				default: `${digitFormat(i + 1)} of the month`,
			}),
		);
		const billingDate = Number(get(home_data)?.billing_date) || 1;
		selectedDay = dayOptions[billingDate - 1];
		initialDay = selectedDay;
	});

	$: hasChanged = selectedDay !== initialDay;

	const saveBillingDate = async () => {
		const date = dayOptions.indexOf(selectedDay) + 1;
		const res = await postReq('/interface/home/save', {
			data: date,
			id: 'billing_date',
		});
		if (res?.isok) {
			home_data.update((home) => {
				home.billing_date = date;
				return home;
			});
			initialDay = selectedDay;
		}
		onSettingsResponse(res);
	};
</script>

<Stack
	direction="column"
	directionMobile="row"
	align="between"
	alignMobile="none"
	gap="m"
	class="align-items-center"
>
	<div>
		<Text class="mb-s" styleType="body">
			{$format('title_billing_date', { default: 'Billing Date' })}
		</Text>
		<SelectV2
			backgroundColor="color-black"
			aria-label={$format('selection_date', { default: 'Date' })}
			bind:value={selectedDay}
			width="full"
			icon="fas fa-calendar-check"
			options={dayOptions}
			id="select-energy-billing-date"
			class="mr-s"
		/>
	</div>

	<ButtonV2 size="m" variant="secondary" disabled={!hasChanged} on:click={saveBillingDate}>
		{$format('button_save')}
	</ButtonV2>
</Stack>
